import { render, staticRenderFns } from "./Jumbotron.vue?vue&type=template&id=f6f76a90&scoped=true&"
import script from "./Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./Jumbotron.vue?vue&type=style&index=0&id=f6f76a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f76a90",
  null
  
)

export default component.exports